module.exports = __webpack_public_path__ + "img/cloud2.c8489174.png";